import type { FunctionComponent, SVGProps } from "react";
import { ReactComponent as ExtraTimeEndIcon } from "assets/icons/match-log/extra-time-end.svg";
import { ReactComponent as ExtraTimeHalfEndIcon } from "assets/icons/match-log/extra-time-half-end.svg";
import { ReactComponent as ExtraTimeSecondHalfStartIcon } from "assets/icons/match-log/extra-time-second-half-start.svg";
import { ReactComponent as ExtraTimeStartIcon } from "assets/icons/match-log/extra-time-start.svg";
import { ReactComponent as FirstHalfEndIcon } from "assets/icons/match-log/first-half-end.svg";
import { ReactComponent as FullTimeIcon } from "assets/icons/match-log/full-time.svg";
import { ReactComponent as KickOffIcon } from "assets/icons/match-log/kick-off.svg";
import { ReactComponent as PenaltiesIcon } from "assets/icons/match-log/penalties.svg";
import { ReactComponent as SecondHalfStartIcon } from "assets/icons/match-log/second-half-start.svg";
import type { MatchLogTimeKind } from "./types";

export const MATCH_LOG_TIME_KIND_ICON_COMPONENTS: Record<
  MatchLogTimeKind,
  FunctionComponent<SVGProps<SVGSVGElement>>
> = {
  kickOff: KickOffIcon,
  firstHalfEnd: FirstHalfEndIcon,
  secondHalfStart: SecondHalfStartIcon,
  fullTime: FullTimeIcon,
  extraTimeStart: ExtraTimeStartIcon,
  extraTimeHalfEnd: ExtraTimeHalfEndIcon,
  extraTimeSecondHalfStart: ExtraTimeSecondHalfStartIcon,
  extraTimeEnd: ExtraTimeEndIcon,
  penalties: PenaltiesIcon,
};
